import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
//Library for cookies
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import {apiService} from '../service/Apiservice'
import debounce from 'lodash/debounce'
import { withTranslation } from "react-i18next";

class Brand extends Component {
	static propTypes = {
		cookies: instanceOf(Cookies).isRequired
	};

	constructor(props) {
		super(props);
		this.state = {
			valueBrand: '',
			selectedModelIndex: '',
			valueYear: '',
			openBrand: false,
			brands : [],
			models: [],
			years:[],
			types:[],
			searchPart:'',
			searchKBA:'',
			language: 'en_en', //TODO check this usage
			cantFind: '',
			cantFindPart: '',
			hover:false,
			allKBA:''
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { t } = this.props;
		if (this.props.forceCookieCreation) {
			this.createCookie()
			this.props.resetForceFlags()
		} else if (this.props.forceCookieRemoval) {
			this.removeCookie()
			this.props.resetForceFlags()
		}

		if (this.props.useCookies !== prevProps.checkbox) {
			// this.handleNameChange()
		}

		if(this.state.valueBrand !== prevState.valueBrand){
			
			this.setState({
				selectedModelIndex:  null,
				valueYear: t("brand.selectYear"),
				valueType: t("brand.selectType"),
				models: [],
                years:[],
				types:[],
			})
		}else if(this.state.selectedModelIndex !== prevState.selectedModelIndex){
			this.setState({
				valueYear: t("brand.selectYear"),
				valueType: t("brand.selectType"),
                years:[],
				types:[],
			})
		}else if(this.state.valueYear !== prevState.valueYear){
			this.setState({
				valueType: t("brand.selectType"),
				types:[],
			})
		}		
	}

	// If checkbox unselected cookie will be deleted - callback
	removeCookie = (removeRegular = true, removeKBA = true) => {
		const { cookies } = this.props;

		if (removeRegular) {
			cookies.remove('cvlrgvehicle', { path: '/' });
		}
		if (removeKBA) {
			cookies.remove('cvlrgvehiclekba', { path: '/' });
		}
	}

	createCookie = () => {
		const { t } = this.props;
		if (this.state.valueType && this.state.valueType !== t("brand.selectType")) {
			this.createCookieDropdown(this.state.valueBrand, this.state.selectedModelIndex, this.state.valueYear, this.state.valueType, this.props.carID)
		} else if (this.state.searchKBA) {
			this.createCookieKBA(this.state.searchKBA, this.props.kind)
		} else {
			console.error('Unhandled state for creating the cookie')
		}
	}

	createCookieDropdown = (selectedBrand, selectedModel, selectedYear, selectedType, carID) => {
		this.removeCookie()
		const { cookies } = this.props;
		let cookieValue = `${selectedBrand}|${selectedModel}|${selectedYear}|${selectedType}|${carID}|${this.props.kind}`
		cookies.set('cvlrgvehicle', cookieValue, { path: '/' });
	}

	readCookieDropdown = () => {
		return this.readCookie('cvlrgvehicle')
	}

	createCookieKBA = (kbaValue, kindID) => {
		this.removeCookie()
		const { cookies } = this.props;
		cookies.set('cvlrgvehiclekba', `${kbaValue}|${kindID}`, { path: '/' });
	}

	readCookieKBA = () => {
		return this.readCookie('cvlrgvehiclekba')
	}

	readCookie = (cookieName) => {
		if (!this.props.useCookies) return null
		const { cookies } = this.props;
		let cookieVal = cookies.get(cookieName)
		return cookieVal ? cookieVal.split('|') : null
	}

	//////////// SELECTION
	onChangeBrand = (event) => {
		this.props.selectDotOne()
		this.handleChangeBrand(event.target.value)
	}

	handleChangeBrand = (brandValue) => {
		this.setState({ valueBrand: brandValue, });

		return apiService.fetchModel(this.props.getLang(), this.props.kind, brandValue)
			.then(response =>{
			this.setState({
				models:response.models,
			})
			
			
		})
	}

	getModelID = () => {
		if (!this.state.models || this.state.models.length === 0 || !this.state.selectedModelIndex) return ''
		return this.state.models[this.state.selectedModelIndex].id
	}

	getModelVariant = () => {
		if (!this.state.models || this.state.models.length === 0 || !this.state.selectedModelIndex) return ''
		return this.state.models[this.state.selectedModelIndex].variant_id
	}

	getModelName = () => {
		if (!this.state.models || this.state.models.length === 0 || !this.state.selectedModelIndex) return this.props.t("brand.selectModel")
		return this.state.models[this.state.selectedModelIndex].name
	}
	onChangeModel = (event) => {
		this.props.selectDotOne()
		this.handleChangeModel(event.target.value)
	}

	handleChangeModel = (currentModelIndex) => {
		this.setState({
			selectedModelIndex: currentModelIndex,
		});
	
		return apiService.fetchYear(this.props.getLang(), this.state.models[currentModelIndex].id,this.state.models[currentModelIndex].variant_id)
		.then(response =>{
			return this.setState({
				years:response.years,
			})
		})
	}

	onChangeYear = (event) => {
		this.props.selectDotOne()
		this.handleChangeYear(event.target.value)
	}

	handleChangeYear = (yearValue) => {
		this.setState({ valueYear: yearValue, });
		
		return apiService.fetchType(this.props.getLang(), this.getModelID(), this.getModelVariant(), yearValue)
		.then(response =>{
			return this.setState({
				types:response.types,
		    	allKBA: response.types, //TODO consider dropping this allKBA state field

			})
		})
		
	}

	onChangeType = (event) => {
		this.props.selectDotOne()
		this.handleChangeType(event.target.value, event.target.childNodes[event.target.value].id) //TODO potential bug with carID!
	}

	handleChangeType = (typeValue, carID) => {
		if (this.props.useCookies) {
			this.createCookieDropdown(this.state.valueBrand, this.state.selectedModelIndex, this.state.valueYear, typeValue, carID)
		}
        
		this.setState({
			valueType: typeValue,
			openBrand: false,

			searchDescription: '',
			searchKBA: this.state.allKBA[typeValue - 
1].kba_number,
			searchPart: '',
		});

		apiService.fetchBulb(this.props.getLang(), carID)
		.then(resBulb =>{
			
			this.props.collectBulbs(resBulb.uses_and_positions)
		})
		//If everything selected then callback completeForm change state in App and passed to ProgresBar, and setState is this open or not.
		var dropdowns = `${this.state.valueBrand}|${this.state.selectedModelIndex}|${this.state.valueYear}|${typeValue}`;
		this.props.completeFormBrand(carID, dropdowns, null, null)
	}

	onChangeKba = debounce(((searchKBA) => {
		this.handleChangeKBA(searchKBA)
	}), 1000);

	handleChangeKBA = (searchKBA, persistCookie = true) => {
		if (!searchKBA) return;
		if (this.props.useCookies && persistCookie) {
			this.createCookieKBA(searchKBA)
		}
		const { t } = this.props;
		apiService
		.fetchbyKba(searchKBA, this.props.kind)
		.then(response => {
			if (!response || !response.uses_and_positions) {
				//have not received anything meaningful 
				this.setState({
					cantFind: t( "brand.cantFindKBA"),
				})
			} else {
				let searchDescription = ''
				let carID = ''
				if (response.uses_and_positions && response.uses_and_positions.length > 0) {
					searchDescription = response.uses_and_positions[0].car_string
					carID = response.uses_and_positions[0].car_id
				}

				this.props.selectDotOne()
				this.props.collectBulbs(response.uses_and_positions)
				this.setState({
					cantFind: "",
					searchPart: "",
					openBrand: false,
					searchDescription: searchDescription,

					valueBrand: this.props.t("brand.selectBrand"),
					models: [],
					selectedModelIndex: null,
					years: [],
					valueYear: this.props.t("brand.selectYear"),
					types: [],
					valueType: this.props.t("brand.selectType"),
				})
				this.props.completeFormBrand(carID, null, null, searchKBA)
			}
		})
	}

	onChangePart = debounce(((searchPart) => {
		this.handleChangePart(searchPart)
	}), 1000);

	handleChangePart = (searchPart) => {
		if (!searchPart) return;
		const { t } = this.props;
		apiService.fetchbyPartNumber(this.props.getLang(), searchPart, this.props.kind)
			.then(resPillar => {
				if (!resPillar.linecard_info) {
					this.setState({
						cantFindPart: t("brand.cantFindPart"),
					})
				} else {
					this.setState({
						cantFindPart: "",
						searchKBA: "",
						openBrand: false,
						searchDescription: searchPart,

						valueBrand: this.props.t("brand.selectBrand"),
						models: [],
						selectedModelIndex: null,
						years: [],
						valueYear: this.props.t("brand.selectYear"),
						types: [],
						valueType: this.props.t( "brand.selectType"),
					})
					this.props.completeFormBrand(null, null, searchPart, null)
					this.props.onSearchByPartSuccess(resPillar.linecard_info)
				}
			})
	}
	//////////// SELECTION END

	componentDidMount() {
		this.setState({
			valueBrand: this.state.valueBrand || this.props.t("brand.selectBrand"),
		})
		this.initBrand()

		// handle query parameter values
		var carID = this.props.carID
		if (this.props.dropdowns) {
			var splinter = this.props.dropdowns.split("|")
			this.handleChangeBrand(splinter[0])
				.then(() => this.handleChangeModel(splinter[1]))
				.then(() => this.handleChangeYear(splinter[2]))
				.then(() => this.handleChangeType(splinter[3], carID))

			this.props.resetFromURL()
			return
		} else if (this.props.kbaNumber && this.props.kind === 1) {
			this.setState({
				searchKBA: this.props.kbaNumber,
			})
			this.handleChangeKBA(this.props.kbaNumber, false)

			this.props.resetFromURL()
			return
		} else if (this.props.partNumber) {
			this.setState({
				searchPart: this.props.partNumber,
			})
			this.handleChangePart(this.props.partNumber)

			this.props.resetFromURL()
			return
		}

		// On start we ask is checkbox-checked or not, it is not checked remove cookie and set start-states
		if (!this.props.useCookies) {
			this.setState({
				valueBrand: this.props.t("brand.selectBrand"), selectedModelIndex: null, valueYear: this.props.t("brand.selectYear"), valueType: this.props.t("brand.selectType"), openBrand: true });
		} else {
			let kbaCookie = this.readCookieKBA()
			let dropdownCookie = this.readCookieDropdown()
			if (kbaCookie && kbaCookie.length === 2) {
				if (this.props.kind === 1) {
					this.setState({
						searchKBA: kbaCookie[0],
					})
					this.handleChangeKBA(kbaCookie[0], false)
				} else {
					//console.log("sorry, you're just not my kind of vehicle")
				}
			} else if (dropdownCookie && dropdownCookie.length === 6) {
				if (parseInt(dropdownCookie[5], 0) === this.props.kind) {
					this.handleChangeBrand(dropdownCookie[0])
					.then(() => this.handleChangeModel(dropdownCookie[1]))
					.then(() => this.handleChangeYear(dropdownCookie[2]))
					.then(() => this.handleChangeType(dropdownCookie[3], dropdownCookie[4]))
				} else {
					//console.log("sorry, you're just not my kind of vehicle")
				}
			} else {
				this.removeCookie()
				console.error('Inconsistent cookie handling state')
			}
		}
	}
	
	initBrand() {
		return apiService.fetchBrand(this.props.getLang(), this.props.kind)
			.then(response => {
			if (response && response.brands) {
				var sortedList = [];
				if (response.brands && response.brands.length > 0) {
					var sortPinYin = require('sort-by-pinyin');
					//Display data from Back-End
					if (this.props.getLang() === "zh_cn") {
						var nameList = response.brands.map((brand, index) => brand.name);
						nameList = sortPinYin(nameList);

						for (let i = 0; i < nameList.length; i++) {
							for (let j = 0; j < response.brands.length; j++) {
								if (nameList[i] === response.brands[j].name) {
									sortedList.push(response.brands[j]);
								}
							}

						}
					}
				}
				if (this.props.getLang() === "zh_cn") {
					this.setState({
						brands: sortedList
					})
				}else{
					this.setState({
						brands: response.brands
					})
				}
			}
			else {
				console.info('Response received without brands');
			}
		});
	}


serachPartNumber = (event) =>{
    this.setState({
	  searchPart:event.target.value
	  
    })
    this.onChangePart(event.target.value)
}

serachKBANumber = (event) =>{
	this.setState({
		searchKBA: event.target.value,
	})
    this.onChangeKba(event.target.value)
  }

  resetValues(isExpanded) {
	  this.setState({
		  openBrand: !isExpanded, 
	  })
  }

  hoverOn=()=>{
	this.setState({ hover: true });
  }
  hoverOff=()=>{ 
	this.setState({ hover: false });    
  }

  renderDropdown(title, name, handlerFunc, items, defaultValue, options, alwaysShow) {
	  if (!alwaysShow && !items) return null;
	  return (
		  <div>
			<h6>{title}</h6>
			<div id={name} className="styled-select">
				<select onChange={handlerFunc} name={name} id={name} disabled={(items && items.length > 0) ? '' : 'disabled'}>
					<option value="" selected >{defaultValue}</option>
					  {/* For model year and type disabled={this.props.useCookies ? true : false} */}
					{options}
				</select>
			</div>
		  </div>
	  )
  }
  	formatTypeLabel = (type) => {
		if (!type && this.state.types && this.state.types.length > 0 && this.state.valueType) {
			type = this.state.types[parseInt(this.state.valueType, 10) - 1]
		}
		if (!type) return ''
			
		return `${type.type_name ? type.type_name : ''} ${type.type_kw}kw  (${type.from_year_month} - ${type.to_year_month})`
	  }

  	formatModelLabel = (model) => {
		if (!model && this.state.models && this.state.models.length > 0 && this.state.selectedModelIndex) {
				model = this.state.models[this.state.selectedModelIndex]
		}
		if (!model) return ''

		let tonnageAndAxles = (this.props.kind && this.props.kind === 2 && model.tonnage && model.axles) ? ' ( ' +  model.tonnage/1000 + 't - ' + model.axles + ' )' : ''
		let variant = (this.props.kind && this.props.kind === 1 && model.variant) ? ' - ' + model.variant : ''
		return `${model.name}${tonnageAndAxles}${variant}`
	  }

	removeDups(names) {
		let unique = {};
		names.forEach(function(i) {
			if(!unique[i]) {
				unique[i] = true;
			}
		});
		return Object.keys(unique);
	}

	render() {
		const { t } = this.props;
		const listBrand = this.state.brands && this.state.brands.length > 0 && this.state.brands.map((brand,index) =>
			<option key={index} value={brand.name} selected={(brand.name === this.state.valueBrand) ? 'selected':''}>{brand.name}</option>
		);
		const listModel = this.state.models && this.state.models.length > 0 && this.state.models.map((model,index) => {
			// eslint-disable-next-line
			return <option key={index} value={index} id={model.name} selected={(index == this.state.selectedModelIndex) ? ' selected' : ''}>{this.formatModelLabel(model)}</option>
		})
		const listYear = this.state.years && this.state.years.length > 0 && this.state.years.map((year,index) => {
			// eslint-disable-next-line
			return <option key={index} value={year} selected={(year == this.state.valueYear) ? ' selected' : ''} > {year} </option>
		})
		const listType = this.state.types && this.state.types.length > 0 && this.state.types.map((type, index) => {
			// eslint-disable-next-line
			return <option key={index} value={index + 1} id={type.car_id} selected={(index == this.state.valueType) ? ' selected' : ''}>{this.formatTypeLabel(type)}</option>
		})
		let isExpanded = this.state.openBrand
		let selected = `${this.state.valueYear} ${this.state.valueBrand} ${this.formatModelLabel()} ${this.formatTypeLabel()}`
		if (this.state.searchDescription) {
			selected = this.state.searchDescription
		}
		if (this.props && this.props.shouldForceExpand()) {
			this.setState({
				openBrand: true, valueYear: t("brand.selectYear"), valueBrand: t("brand.selectBrand"), searchDescription: '' })
			isExpanded = true;
			selected = ''
		}

		return (
			<div>
				<Panel id="collapsible-panel-example-1" expanded={isExpanded} className="row" onToggle={() => { }}>
					<Panel.Collapse className="col-xs-12">
						<Panel.Body className="brand-parent">
							<h4>{t("brand.brandTitle")}</h4>
							<div className="row">
								<div className="col-md-6 brand-br">
									<div className="brand-select">
										<h5>{t("brand.findYourVehicle")}</h5>
										<form onSubmit={this.handleSubmit}>
											{this.renderDropdown(t("brand.brand"), "brand", this.onChangeBrand, this.state.brands, t("brand.selectBrand"), listBrand, true)}
											{this.renderDropdown(t("brand.model"), "model", this.onChangeModel, this.state.models, t("brand.selectModel"), listModel, true)}
											{this.renderDropdown(t("brand.year"), "year", this.onChangeYear, this.state.years, t("brand.selectYear"), listYear, true)}
											{this.renderDropdown(t("brand.type"), "type", this.onChangeType, this.state.types, t("brand.selectType"), listType, true)}
										</form>
									</div>
								</div>
							</div>
						</Panel.Body>
					</Panel.Collapse>
					{/*Display + or - , toogle openBrand and show minus or plus*/}
					<div onClick={() => this.resetValues(isExpanded)} className={(isExpanded) ? "" : "col-xs-12"}>
						<div className={(isExpanded) ? "accordion-icon ms-icon_minus" : "accordion-icon ms-icon_plus"}>
							</div>
							{/* Display or not when accordion expand or colapse , and on change can open or collapse panel*/}
						<div className={(isExpanded) ? "none" : "brand-small display"} >
							<h4>{t("brand.brandTitle")}</h4>
							<p>{selected} <span className="change" onClick={() => this.resetValues(isExpanded)} >{t("brand.change")}</span></p>
						</div>
					</div>
				</Panel>
			</div>
		);
	}
}

//export default withCookies(Brand);
const cookieWrap = withCookies(Brand);
export default withTranslation()(cookieWrap);
